import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'app-test-primeng',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule],
  templateUrl: './test-primeng.component.html',
  styleUrl: './test-primeng.component.css'
})

export class TestPrimengComponent {
  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  associatesList: any;
  monthDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.timesheet');
    if (isPlatformBrowser(this.platformId)) {
      this.getAssociates();
    }
  }

  getAssociates() {
    this.ts.getMonthList()
      .subscribe({
        next: (resMonthList: any) => {
          this.monthDropdown = resMonthList.data;
          // console.log(this.monthDropdown);
          this.getAssociatesList('2025-07-01');
        },
        error: (err: any) => {
          console.log(err);
		  if (err.status == 401) {
			  this.auth.logout();
			  return
			}
        }
      });

  }

  fncCng(event: any) {
    let dateFormat = this.getDateFromEvent(event);
    this.getAssociatesList(dateFormat);
  }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getAssociatesList(dateFormat: string) {

    this.ts.getAssociates(dateFormat)
      .subscribe({
        next: (res: any) => {
          this.associatesList = this.applyEncryption(res.data);
          this.updateVisibleData();
        },
        error: (err: any) => {
			if (err.status == 401) {
			  this.auth.logout();
			  return
			}
        }
      });

  }
  ngAfterViewInit() {
    // Initially set to full dataset
    // this.filteredData = [...this.associatesList];
    setTimeout(() => this.updateVisibleData(), 0);
  }
  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }
  onPage(event: any) {
    this.updateVisibleData(event);
  }
  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2.filteredValue ?? this.associatesList;
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }
  // Compute totals dynamically
  get totalRegular() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.regular || 0), 0);
  }
  
  get totalOverTime() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.overtime || 0), 0);
  }
  get totalMn() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.midnightOvertime || 0), 0);
  }
  get overAllTotal() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.total || 0), 0);
  }
  get totalNotSubmit() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.notSubmit || 0), 0);
  }
  get totalSubmit() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.submit || 0), 0);
  }
  get totalReject() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.reject || 0), 0);
  }
  get totalApprove() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.approve || 0), 0);
  }
  get totalHome() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.teleWork || 0), 0);
  }
  get totalAbsence() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.absence || 0), 0);
  }
  get totalPh() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.paidHoliday || 0), 0);
  }

  getMonthYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      dt[ind].timesheetID = this.en.encryptionAES(elm.timesheetID.toString())
    });
    return dt;
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  // getColumnTotal(field: string) {
  //   return this.associatesList.reduce((sum, item) => sum + (item[field] || 0), 0);
  // }
}